import React, { FC, Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { CustomerWithOperations } from '../../interfaces/Customer';
import { OperationStateIcon } from './OperationStateIcon';
import {
  Wrapper,
  HeadlineWrapper,
  Headline,
  EditIconWrapper,
  EditIcon,
  AdditionalItemDivider,
  DataWrapper,
  DataRow,
  DataRowHeader,
  DataRowContent,
} from './AdditionalListContentUI';
import { formatDate } from '../../utils/DateUtils';
import styled from 'styled-components';
import { Colors } from '../..';
import { AnimatedContainer, calculateAnimationDelayItemsAppear } from '../general/AnimatedContainer';

export interface AdditionalCustomersListContentProps {
  item: CustomerWithOperations;
  editRoute: string;
  operationEditRoute?: string;
  collapsed: boolean;
}

const LoadMoreButton = styled.button`
  color: ${Colors.primary};
  border: none;
  &:hover {
    cursor: pointer;
    color: ${Colors.primaryLight};
  }  
`;

export const AdditionalCustomersListContent: FC<AdditionalCustomersListContentProps> = (props) => {
  const { item, editRoute, operationEditRoute, collapsed } = props;

  const baseLimit: number = 8;
  const [limit, setLimit] = useState<number>(baseLimit);

  const updateLimit = () => {
    setLimit(limit + baseLimit);
  };

  return (
    <Wrapper>
      <HeadlineWrapper>
        <Headline>Unternehmensdaten</Headline>
        <EditIconWrapper>
          <Link to={editRoute.replace('{id}', item.id || item.localUuid)}>
            <EditIcon icon={'edit'} size={22} />
          </Link>
        </EditIconWrapper>
      </HeadlineWrapper>

      <AdditionalItemDivider />

      {
        item?.operations?.length > 0 ? (
          <>
            <DataWrapper>
              {
                item.operations.filter((item, index) => index < limit).map((operation, index, array) => (
                  <AnimatedContainer active={!collapsed} delay={calculateAnimationDelayItemsAppear(!collapsed, index, array.length)} key={index}>
                    <DataRow>
                      <DataRowHeader>Gesprächsprotokoll vom {formatDate(operation.updatedAt)} {operation.status &&
                      <strong>({'Status:'} <OperationStateIcon textOnly
                                                               value={operation.status} />)</strong>}</DataRowHeader>
                      <DataRowContent>
                        <EditIconWrapper>
                          <Link to={
                            (
                              operationEditRoute?.replace('{id}', item.id || item.localUuid)
                                .replace('{operationId}', operation.id)
                            ) || `/operations/${operation.id}`
                          }>
                            <EditIcon icon={'edit'} size={20} />
                          </Link>
                        </EditIconWrapper>
                      </DataRowContent>
                    </DataRow>
                    <AdditionalItemDivider />
                  </AnimatedContainer>
                ))
              }
            </DataWrapper>

            {
               (limit <= item.operations.length) && (<LoadMoreButton onClick={updateLimit}>mehr anzeigen</LoadMoreButton>)
            }

          </>
        ) : <DataRow>Keine Vorgänge gefunden</DataRow>
      }
    </Wrapper>
  );
};
